import ExclamationInTriangleIcon from '@/assets/icons/icon-exclamation-in-triangle.svg'

export const ModuleFallback = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center bg-secondary-100 dark:bg-secondary-700">
      <div className="p-5 rounded-md flex flex-col items-center gap-4 max-w-[298px] bg-secondary-50 dark:bg-secondary-600">
        <div className="flex flex-col gap-2 text-secondary-300 text-center items-center">
          <ExclamationInTriangleIcon />
          <p className="text-sm leading-[22px]">
            We couldn’t load this section. Please try again.
          </p>
        </div>
      </div>
    </div>
  )
}
